export default __webpack_public_path__ + "static/media/dog.e6d8067d.png";